import { queryClient } from '@frontend/sorghum/external-providers';
import {
  PatchCommentReplyConditionRequest,
  Response,
} from '@frontend/sorghum/interface';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_CONDITION } from '../apis';

async function patchCommentReplyCondition(
  props: PatchCommentReplyConditionRequest,
) {
  return axios
    .patch(COMMENT_REPLY_CONDITION, props)
    .then((res) => res.data)
    .catch((err) => ({
      code: 400,
      msg: err,
    }));
}

export function usePatchCommentReplyCondition() {
  return useMutation({
    mutationKey: ['patch-comment-reply-condition'],
    mutationFn: (props: PatchCommentReplyConditionRequest) =>
      patchCommentReplyCondition(props),
    onSuccess: (
      response: Response,
      props: PatchCommentReplyConditionRequest,
    ) => {
      if (response.code === 20000) {
        queryClient.refetchQueries(['get-comment-reply', { uuid: props.id }]);
        queryClient.invalidateQueries(['get-comment-reply-condition']);
        // v1/v2 是同一份 condition 的不同 API 版本：手機表單讀 v2、
        // 但 Threads 走 v1 存檔，若不一起 invalidate v2，存完不重整就不會更新。
        queryClient.invalidateQueries(['get-comment-reply-condition-v2']);
      }
    },
  });
}
